import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import PREBUILT_CARD_DETAILS from '#core/application/modules/cards-and-promotions/classic-cards/pre-built-cards/prebuilt-card-details.palette-schema.yaml';

import {AvantgardeCards} from '../avantgarde-cards.js';

import {avantgardePreBuiltCardsFactory} from './avantgarde-pre-built-cards.factory.js';

import PALETTE_SCHEMA from './avantgarde-pre-built-cards.palette-schema.yaml';

registerTileSchema(PREBUILT_CARD_DETAILS);

class AvantgardePreBuiltCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'AvantgardePreBuiltCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return avantgardePreBuiltCardsFactory(PALETTE);
    }
}

new AvantgardePreBuiltCardsFeature(AvantgardeCards);
